import classNames from 'classnames'
import { IFeedData } from 'lib/fetch-community-feed'
import getLinkHref from 'lib/get-link-href'
import React from 'react'
import SquareDuration from './square-duration'

export default function VideoCard({
  data,
  className,
  onClick,
}: {
  data: IFeedData
  className?: string
  onClick?: () => void
}) {
  const {
    unique_id_str,
    info: { video_duration, title, image_list },
    type,
  } = data
  const isUGC = type < 2000 || type >= 2300
  const href = `/${isUGC ? 'ugc/' : ''}article/${unique_id_str}`
  return (
    <div className={classNames('container', className)} onClick={onClick}>
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a href={href} target="_blank" className="cover">
        <div className="zoom" />
        <SquareDuration duration={video_duration} className="video-duration" />
      </a>
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a href={href} target="_blank">
        <div className="title line-2">{title}</div>
      </a>
      <style jsx>
        {`
        .container{
          width: 276px;
          height: 232px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .cover{
          width: 276px;
          height: 184px;
          border-radius: 2px;
          overflow: hidden;
          position: relative;
        }
        .zoom{
          width: 100%;
          height: 100%;
          background-image: url('${image_list?.[0]?.url}');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
        :global(.container .video-duration){
          position: absolute;
          right: 4px;
          bottom: 4px;
        }
        .title{
          color: #1f2129;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          height: 40px;
        }
        .title:hover{
          color: #e62021;
        }
      `}
      </style>
    </div>
  )
}
